import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-span-12" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = { class: "col-span-6" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-6" }
const _hoisted_11 = { class: "col-span-12" }

import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import { ref } from 'vue';
import { numberonly } from '@/helpers/NumberHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
    form: {
        type: Object,
    },
    errors: {
        type: Array,
        default: () => []
    },
    regions: {
        type: Array,
        default: () => []
    },
    provinces: {
        type: Array,
        default: () => []
    },
    cities: {
        type: Array,
        default: () => []
    },
    barangays: {
        type: Array,
        default: () => []
    }
},
  setup(__props) {

const props = __props;

const item = ref(props.form)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormSection, null, {
    title: _withCtx(() => [...(_cache[15] || (_cache[15] = [
      _createTextVNode(" Branch Information ", -1)
    ]))]),
    description: _withCtx(() => [...(_cache[16] || (_cache[16] = [
      _createTextVNode(" Relevant data and other details ", -1)
    ]))]),
    form: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TextInput, {
          label: "Branch Name",
          placeholder: "Branch Name",
          id: "name",
          name: "name",
          modelValue: item.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.name) = $event)),
          error: __props.errors.name ? __props.errors.name[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextInput, {
          label: "Address Line",
          placeholder: "Address Line",
          id: "address_line",
          name: "address_line",
          modelValue: item.value.address_line,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.address_line) = $event)),
          error: __props.errors.address_line ? __props.errors.address_line[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MultiselectInput, {
          id: "regions",
          label: "Region",
          name: "regions",
          modelValue: item.value.region_code,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.region_code) = $event)),
          placeholder: "Region",
          options: __props.regions,
          searchable: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clearProvince'))),
          error: __props.errors.region_code ? __props.errors.region_code[0] : ''
        }, null, 8, ["modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MultiselectInput, {
          id: "province",
          name: "province",
          label: "Province",
          modelValue: item.value.province_code,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.province_code) = $event)),
          placeholder: "Province",
          options: __props.provinces,
          searchable: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('clearCity'))),
          error: __props.errors.province_code ? __props.errors.province_code[0] : ''
        }, null, 8, ["modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(MultiselectInput, {
          id: "city",
          name: "city",
          label: "City",
          modelValue: item.value.city_code,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((item.value.city_code) = $event)),
          placeholder: "City",
          options: __props.cities,
          searchable: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('clearBgy'))),
          error: __props.errors.city_code ? __props.errors.city_code[0] : ''
        }, null, 8, ["modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(MultiselectInput, {
          id: "barangay",
          name: "barangay",
          label: "Barangay",
          modelValue: item.value.barangay_code,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.barangay_code) = $event)),
          placeholder: "Barangay",
          options: __props.barangays,
          searchable: "",
          error: __props.errors.barangay_code ? __props.errors.barangay_code[0] : ''
        }, null, 8, ["modelValue", "options", "error"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(TextInput, {
          label: "Zip Code",
          placeholder: "Zip Code",
          id: "zip_code",
          name: "zip_code",
          modelValue: item.value.zip_code,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((item.value.zip_code) = $event)),
          error: __props.errors.zip_code ? __props.errors.zip_code[0] : ''
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(TextInput, {
          id: "mobile_number",
          name: "mobile_number",
          label: "Mobile Number",
          "add-on-left": true,
          "add-on-text": "+63",
          onKeypress: _unref(numberonly),
          placeholder: "Mobile Number",
          maxlength: 10,
          modelValue: item.value.mobile_number,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((item.value.mobile_number) = $event)),
          error: __props.errors.mobile_number ? __props.errors.mobile_number[0] : ''
        }, null, 8, ["onKeypress", "modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(TextInput, {
          type: "time",
          label: "Start Time",
          placeholder: "Start Time",
          id: "start_time",
          name: "start_time",
          modelValue: item.value.start_time,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((item.value.start_time) = $event)),
          error: __props.errors.start_time ? __props.errors.start_time[0] : '',
          step: 60,
          helper: "Do not include minutes"
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(TextInput, {
          type: "time",
          label: "End Time",
          placeholder: "End Time",
          id: "end_time",
          name: "end_time",
          modelValue: item.value.end_time,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((item.value.end_time) = $event)),
          error: __props.errors.end_time ? __props.errors.end_time[0] : '',
          step: 60,
          helper: "Do not include minutes"
        }, null, 8, ["modelValue", "error"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(DropzoneInput, {
          file: item.value.image_path,
          "onUpdate:file": _cache[13] || (_cache[13] = ($event: any) => ((item.value.image_path) = $event)),
          path: item.value.image_path,
          "onUpdate:path": _cache[14] || (_cache[14] = ($event: any) => ((item.value.image_path) = $event)),
          label: "Image",
          error: __props.errors.image_path ? __props.errors.image_path[0] : ''
        }, null, 8, ["file", "path", "error"])
      ])
    ]),
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})